<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :btnOffset="19"
  :btnSpan="6"
  :inline="true"
  >
	<Row class="mb16" :gutter="16">
		<Col span="6">
			<Select v-model="searchData.projectFid" placeholder="项目名称" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
		<Col span="6">
			<DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="活动日期筛选"></DatePicker>
		</Col>
    <Col span="6">
			<Input v-model="searchData.activityName" type="text" placeholder="请搜索活动名称"></Input>
		</Col>
	</Row>
	</search-group>
</template>

<script>

import SearchGroup from 'components/SearchGroup/index';
import { formatDateTime } from "../../../../../../utils/format";

export default {
	components:{
		SearchGroup
	},
	props:{
		projectList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	computed:{
		searchParams(){
			function f(data) {
        return data?formatDateTime(data, false):''
			}
			return {
				projectFid:this.searchData.projectFid,
				startDate:f(this.searchData.createTime[0]),
				endDate:f(this.searchData.createTime[1]),
				activityName:this.searchData.activityName,
			}
		}
	},
	data(){
		return{
			searchData:{
				projectFid:'',
				createTime:['',''],
				activityName:'',
			}
		}
	},
	mounted(){
		this.$emit('searchParams',this.searchParams)
	},
	methods:{
		clearValue(){
			this.searchData = {
				projectFid:'',
				createTime:['',''],
				activityName:'',
			}
		},
		findData(){
			console.log(this.searchParams)
			this.$emit('searchParams',this.searchParams)
		},
	}
}
</script>

<style>

</style>